import React from 'react';

const SkeletonPulse = ({ className = '' }) => (
  <div className={`animate-pulse bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700 bg-[length:200%_100%] rounded ${className}`}
    style={{ animation: 'shimmer 1.5s ease-in-out infinite' }}
  />
);

export const FeedSkeleton = () => (
  <div className="space-y-6" data-testid="feed-skeleton">
    {[0, 1, 2].map((i) => (
      <div key={i} className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 p-6" style={{ animationDelay: `${i * 150}ms` }}>
        <div className="flex items-start gap-4">
          <SkeletonPulse className="h-12 w-12 rounded-full flex-shrink-0" />
          <div className="flex-1 space-y-3">
            <div className="flex items-center gap-3">
              <SkeletonPulse className="h-4 w-32 rounded-md" />
              <SkeletonPulse className="h-3 w-20 rounded-md" />
            </div>
            <SkeletonPulse className="h-4 w-full rounded-md" />
            <SkeletonPulse className="h-4 w-3/4 rounded-md" />
            <SkeletonPulse className="h-40 w-full rounded-xl mt-2" />
            <div className="flex items-center gap-6 pt-3 border-t border-gray-100 dark:border-gray-700">
              <SkeletonPulse className="h-8 w-20 rounded-lg" />
              <SkeletonPulse className="h-8 w-16 rounded-lg" />
              <SkeletonPulse className="h-8 w-20 rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const ProfileSkeleton = () => (
  <div className="space-y-6" data-testid="profile-skeleton">
    <div className="bg-white dark:bg-gray-800 rounded-2xl overflow-hidden">
      <SkeletonPulse className="h-52 w-full rounded-none" />
      <div className="px-6 py-6">
        <div className="flex items-end gap-4 -mt-16 mb-4">
          <SkeletonPulse className="h-28 w-28 rounded-full border-4 border-white dark:border-gray-800" />
          <div className="flex-1 space-y-2 pt-12">
            <SkeletonPulse className="h-6 w-48 rounded-md" />
            <SkeletonPulse className="h-4 w-32 rounded-md" />
          </div>
        </div>
        <div className="flex gap-3">
          <SkeletonPulse className="h-8 w-24 rounded-full" />
          <SkeletonPulse className="h-8 w-24 rounded-full" />
          <SkeletonPulse className="h-8 w-24 rounded-full" />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 space-y-6">
        {[0, 1].map((i) => (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-2xl p-6">
            <SkeletonPulse className="h-5 w-40 rounded-md mb-4" />
            <SkeletonPulse className="h-4 w-full rounded-md mb-2" />
            <SkeletonPulse className="h-4 w-2/3 rounded-md" />
          </div>
        ))}
      </div>
      <div className="space-y-6">
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-6">
          <SkeletonPulse className="h-5 w-32 rounded-md mb-4" />
          <div className="flex flex-wrap gap-2">
            {[0, 1, 2, 3].map((i) => (
              <SkeletonPulse key={i} className="h-7 w-20 rounded-full" />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const DiscoverSkeleton = () => (
  <div className="space-y-4" data-testid="discover-skeleton">
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="bg-white dark:bg-gray-800 rounded-2xl border-2 border-gray-100 dark:border-gray-700 p-5" style={{ animationDelay: `${i * 100}ms` }}>
        <div className="flex items-start gap-4">
          <SkeletonPulse className="h-16 w-16 rounded-full flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <SkeletonPulse className="h-5 w-36 rounded-md" />
            <SkeletonPulse className="h-3 w-full rounded-md" />
            <SkeletonPulse className="h-3 w-2/3 rounded-md" />
            <div className="flex gap-2 pt-1">
              <SkeletonPulse className="h-6 w-16 rounded-full" />
              <SkeletonPulse className="h-6 w-20 rounded-full" />
              <SkeletonPulse className="h-6 w-14 rounded-full" />
            </div>
          </div>
          <div className="space-y-2">
            <SkeletonPulse className="h-9 w-24 rounded-lg" />
            <SkeletonPulse className="h-9 w-24 rounded-lg" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default SkeletonPulse;
